var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "-4 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2911 4.89899C14.7459 2.23244 12.0014 0.603334 8.94941 0.541076C8.81912 0.538391 8.68799 0.538391 8.55766 0.541076C5.50573 0.603334 2.7612 2.23244 1.21599 4.89899C-0.363433 7.62461 -0.406646 10.8986 1.10038 13.657L7.41384 25.2129C7.41668 25.218 7.41951 25.2231 7.42245 25.2282C7.70022 25.711 8.19784 25.9992 8.75363 25.9992C9.30938 25.9992 9.807 25.711 10.0847 25.2282C10.0877 25.2231 10.0905 25.218 10.0933 25.2129L16.4068 13.657C17.9137 10.8986 17.8705 7.62461 16.2911 4.89899ZM8.75353 12.0757C6.77933 12.0757 5.1732 10.4696 5.1732 8.49538C5.1732 6.52118 6.77933 4.91505 8.75353 4.91505C10.7277 4.91505 12.3339 6.52118 12.3339 8.49538C12.3339 10.4696 10.7278 12.0757 8.75353 12.0757Z",
    fill: "#737B7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLocation);
export default __webpack_public_path__ + "static/media/modal-location.5eeeb8a8935aed4cd14d961d254d08f8.svg";
export { ForwardRef as ReactComponent };